function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Close } from "@mui/icons-material";
import { CircularProgress, Divider, IconButton, Modal as MuiModal, styled } from "@mui/material";
import cn from "clsx";
import { useCallback, useId, useMemo } from "react";
import { ModalBody } from "./ModalBody";
import { ModalContainer } from "./ModalContainer";
import { ModalHeader } from "./ModalHeader";
var ModalLoader = styled('div', {
    name: 'modalLoader'
})({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    minHeight: 350,
    width: '100%'
});
export var Modal = function(_param) {
    var _param_confirmMessage = _param.confirmMessage, confirmMessage = _param_confirmMessage === void 0 ? 'Your data is not saved yet. Are you sure you want to close the form?' : _param_confirmMessage, props = _object_without_properties(_param, [
        "confirmMessage"
    ]);
    var _props_styles, _props_styles1;
    var labelId = useId();
    var ariaLabelledBy = useMemo(function() {
        return typeof props.header === 'string' ? labelId : undefined;
    }, [
        labelId,
        props.header
    ]);
    var handleClose = useCallback(function() {
        if (!props.requireConfirmOnClose) {
            return props.onRequestClose();
        }
        if (window.confirm(confirmMessage)) {
            props.onRequestClose();
        }
    }, [
        confirmMessage,
        props.onRequestClose,
        props.requireConfirmOnClose
    ]);
    var _props_arialabelledby;
    return /*#__PURE__*/ _jsx(MuiModal, {
        className: "fixed flex top-0 right-0 left-0 justify-center items-center",
        onClose: props.locked ? undefined : handleClose,
        open: !!(props.locked || props.isOpen),
        role: "presentation",
        slotProps: {
            backdrop: {
                className: (_props_styles = props.styles) === null || _props_styles === void 0 ? void 0 : _props_styles.overlay
            }
        },
        children: /*#__PURE__*/ _jsxs(ModalContainer, {
            "aria-describedby": props['aria-describedby'],
            "aria-label": props['aria-label'],
            "aria-labelledby": (_props_arialabelledby = props['aria-labelledby']) !== null && _props_arialabelledby !== void 0 ? _props_arialabelledby : ariaLabelledBy,
            className: (_props_styles1 = props.styles) === null || _props_styles1 === void 0 ? void 0 : _props_styles1.container,
            "data-component": "modalContainer",
            "data-testid": props['data-testid'],
            lgWidth: props.lgWidth,
            mdWidth: props.mdWidth,
            role: props.role || 'dialog',
            children: [
                !props.isLoading && props.header && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(ModalHeader, {
                            id: ariaLabelledBy,
                            children: props.header
                        }),
                        /*#__PURE__*/ _jsx(Divider, {})
                    ]
                }),
                props.isLoading ? /*#__PURE__*/ _jsx(ModalBody, {
                    isRounded: !props.header,
                    children: /*#__PURE__*/ _jsx(ModalLoader, {
                        children: /*#__PURE__*/ _jsx(CircularProgress, {})
                    })
                }) : props.children,
                props.closeButton && /*#__PURE__*/ _jsx(IconButton, {
                    "aria-label": "close",
                    className: cn('text-black absolute', {
                        'top-1 right-0': !!props.header,
                        'top-2 right-2': !props.header
                    }),
                    onClick: handleClose,
                    children: /*#__PURE__*/ _jsx(Close, {})
                })
            ]
        })
    });
};
Modal.displayName = 'Modal';

//# sourceMappingURL=Modal.js.map